// extracted by mini-css-extract-plugin
export default {"rect":"oU9ud","light":"J1rQN","gray":"Zxa1b"};